module.exports = __webpack_public_path__ + "img/download_blue.59f42117.png";